import { getSelectedCompany } from "../utils/auth";
import { getAdminId, getRegisterId } from "../utils/authId";

const frontendUrl = process.env.REACT_APP_FRONTEND_SOCKET_URL;

class WebSocketOnline {
  static instance = null;
  socket = null;
  reconnectAttempts = 0;
  maxReconnectAttempts = 5;
  callbacks = {
    onmessage: null,
    onclose: null,
    onerror: null,
  };

  constructor() {
    if (WebSocketOnline.instance) {
      return WebSocketOnline.instance;
    }
    WebSocketOnline.instance = this;

    // Add beforeunload event listener
    if (typeof window !== "undefined") {
      window.addEventListener(
        "beforeunload",
        this.handleBrowserClose.bind(this)
      );
    }
  }

  connect(token) {
    const userId = getRegisterId() || {};
    const admin_id = getAdminId() || {};
    const companyId = getSelectedCompany();
    if (this.socket) {
      return;
    }

    this.socket = new WebSocket( // Fixed: changed webSocket to WebSocket (correct casing)
      `${frontendUrl}/ws/online_consumer/${userId}/?token=${token}`
    );

    this.socket.onopen = () => {
      this.reconnectAttempts = 0;
      try {
        this.socket.send(
          JSON.stringify({
            type: "open",
            admin_id: admin_id,
            company_id: companyId.id,
          })
        );
      } catch (error) {}
    };

    this.socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        this.callbacks.onmessage && this.callbacks.onmessage(data);
      } catch (error) {}
    };

    this.socket.onclose = (event) => {
      this.socket = null;
      this.callbacks.onclose && this.callbacks.onclose(event);
      if (
        event.code !== 1000 &&
        this.reconnectAttempts < this.maxReconnectAttempts
      ) {
        const timeout = Math.min(1000 * 2 ** this.reconnectAttempts, 30000);
        setTimeout(() => {
          this.reconnectAttempts++;
          this.connect(token);
        }, timeout);
      }
    };

    this.socket.onerror = (error) => {
      this.callbacks.onerror && this.callbacks.onerror(error);
    };
  }

  disconnect() {
    const admin_id = getAdminId() || {};
    const companyId = getSelectedCompany() || {};
    if (this.socket) {
      // Send an offline notification to the server before closing
      try {
        this.socket.send(
          JSON.stringify({
            type: "close",
            admin_id: admin_id,
            company_id: companyId.id,
          })
        );
      } catch (e) {}

      this.socket.close(1000, "User initiated disconnect");
      this.socket = null;
    }
  }

  handleBrowserClose() {
    // const admin_id = getAdminId() || {};
    // const companyId = getSelectedCompany();
    // This will be called when the browser/tab is closing
    // if (this.socket && this.socket.readyState === WebSocket.OPEN) {
    //   // Try to send an immediate offline notification
    //   try {
    //     this.socket.send(
    //       JSON.stringify({
    //         type: "close",
    //         admin_id: admin_id,
    //         company_id: companyId.id,
    //       })
    //     );
    //   } catch (e) {}
    //   // Close the connection immediately
    //   this.socket.close();
    // }
  }

  // Cleanup method to remove event listeners
  // cleanup() {
  //   if (typeof window !== "undefined") {
  //     window.removeEventListener(
  //       "beforeunload",
  //       this.handleBrowserClose.bind(this)
  //     );
  //   }
  //   this.disconnect();
  // }
}
const webSocket = new WebSocketOnline();
export default webSocket;
